import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import QRCode from 'qrcode';

export const challengeQrOptions = {
  errorCorrectionLevel: 'M',
  margin: 2,
  width: 240,
  color: { dark: '#000000', light: '#FFFFFF' },
};

export default function ChallengeQr({ payload }) {
  const [dataUrl, setDataUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setDataUrl('');
    setFailed(false);
    if (!payload) return undefined;
    QRCode.toDataURL(payload, challengeQrOptions)
      .then((url) => {
        if (active) setDataUrl(url);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [payload]);

  if (!payload) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <Box
        data-qr-payload={payload}
        sx={{ bgcolor: '#FFFFFF', color: '#000000', p: 1.5, borderRadius: 1, lineHeight: 0, maxWidth: '100%' }}
      >
        {dataUrl ? (
          <Box
            component="img"
            src={dataUrl}
            alt="QR Code"
            sx={{ width: 240, maxWidth: '100%', height: 'auto', display: 'block' }}
          />
        ) : null}
        {!dataUrl && failed ? (
          <Typography color="error" sx={{ lineHeight: 1.4 }}>Não foi possível desenhar o QR.</Typography>
        ) : null}
        {!dataUrl && !failed ? <CircularProgress size={28} sx={{ m: 2 }} /> : null}
      </Box>
    </Box>
  );
}
